<template>
  <div class="box-detail product">
    <div class="box-left">
      <div class="box-left-header">
        <div
          @click="$router.push({ path: '/WarrantyProductInventorys' })"
          class="goBack c-position-static c-m-0"
        >
          <i class="el-icon-arrow-left"></i>
          <span>质保卡库存</span>
          <i class="el-icon-box"></i>
        </div>
        <div class="c-m-r-10">
          <el-tag effect="plain" v-if="formData.productState == '0'">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '1'">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '3'" type="success">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState == '4'" type="danger">
            {{ formatProductState(formData.productState) }}
          </el-tag>
          <el-tag effect="dark" v-else-if="formData.productState" type="info">
            {{ formatProductState(formData.productState) }}
          </el-tag>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          :formData="formData"
          :upload="upload"
          :fields="extFields"
          :options="options"
          ref="form"
          labelWidth="140px"
          v-if="isShow"
          @changeForm="osg.changeForm"
        >
          <template slot="partnerName">
            <el-select
              v-model="formData.partnerId"
              @change="handlePartnerSelect"
              @clear="
                querypartnerSearch();
                delete formData.partnerName;
                delete formData.partnerCode;
                delete formData.orgId;
                delete formData.partnerId;

                delete formData.warrantyProductName;
                delete formData.warrantyProductCode;
                delete formData.warrantyProductId;
              "
              placeholder="请选择伙伴"
              clearable
              filterable
              remote
              :remote-method="querypartnerSearch"
            >
              <el-option
                v-for="item in options.partners"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </template>
          <template slot="warrantyProductName">
            <el-select
              v-model="formData.warrantyProductId"
              @change="selectWarrantyProductChange"
              @clear="getWarrantyProducts(null)"
              clearable
              filterable
              placeholder="请选择质保卡产品"
            >
              <!-- remote -->
              <!-- :remote-method="getWarrantyProducts" -->
              <el-option
                v-for="item in options.warrantyProducts"
                :key="item._id"
                :label="item.label"
                :value="item._id"
              ></el-option>
            </el-select>
          </template>
          <!-- <template slot="warrantyProductProductList">
          <el-select
            v-model="formData.warrantyProductProductList"
            clearable
            placeholder="请选择质保卡产品"
          >
            <el-option
              v-for="item in options.productBizType.filter(item =>
                formData.warrantyProductProductList.includes(item.value)
              )"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->

          <!-- <template slot="productList">
          <el-select
            v-model="formData.productList"
            @change="$forceUpdate()"
            @clear="getProduct"
            clearable
            multiple
            remote
            :remote-method="getProduct"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options.product"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template> -->
          <!-- <template slot="countryUse">
          <el-select v-model="formData.countryUse" clearable placeholder="请选择">
            <el-option
              v-for="item in options.isNational"
              :key="item.value"
              :label="item.label"
              :value="Boolean(item.value)"
            ></el-option>
          </el-select>
        </template> -->
          <!-- <template slot="orgIds">
          <el-cascader
            v-model="formData.orgIds"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            clearable
          ></el-cascader>
        </template> -->
        </c-form>
        <div
          v-if="
            Array.isArray(options.productBizType) &&
              Array.isArray(formData.exts.warrantyProductProductScopeList)
          "
        >
          <span>使用防水产品</span>
          <el-checkbox-group
            style="margin-top:10px"
            v-model="formData.exts.warrantyProductProductScopeList"
            @change="$forceUpdate()"
          >
            <el-checkbox
              v-for="item in options.productBizType.filter(item =>
                formData.exts.warrantyProductProductScopeList.includes(item.value)
              )"
              :label="item.value"
              :key="item.value"
              disabled
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div
        class="box-left-footer"
        v-if="formData.status == 0 && osg.has('WarrantyProductInventory,edit')"
      >
        <el-button type="primary" @click="doSave()">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes" v-if="false">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <!-- <el-collapse v-model="activeCollapse">
          <el-collapse-item name="1">
            <template slot="title">
              <span>依赖产品展示</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of formData.dependProList" :key="i">
                <div>
                  <i class="el-icon-box card-item-logo" style="color: #606266;"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/Product/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p>
                    <span>型号：{{ item.code }}</span>
                  </p>
                  <p>
                    <span>单位：{{ osg.codelabel('unit', item.unit) }}</span>
                  </p>
                  <p>
                    <span>价格：{{ item.price }}元</span>
                  </p>
                  <p>
                    <span>产品类型：{{ osg.codelabel('productType', item.productType) }}</span>
                  </p>
                  <p>
                    <span>
                      业务类型：{{ osg.codelabel('productBizType', item.productBizType) }}
                    </span>
                  </p>
                  <p>
                    <span>依赖产品：{{ osg.codelabelForArray('product', item.depends) }}</span>
                  </p>
                  <p>
                    <span>子产品：{{ osg.codelabelForArray('product', item.childs) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <span>子产品展示</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of formData.productList" :key="i">
                <div>
                  <i class="el-icon-box card-item-logo" style="color: #606266;"></i>
                </div>
                <div>
                  <p>
                    <el-link :href="'/Product/' + item._id" target="_blank">
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p>
                    <span>型号：{{ item.code }}</span>
                  </p>
                  <p>
                    <span>单位：{{ osg.codelabel('unit', item.unit) }}</span>
                  </p>
                  <p>
                    <span>价格：{{ item.price }}元</span>
                  </p>
                  <p>
                    <span>产品类型：{{ osg.codelabel('productType', item.productType) }}</span>
                  </p>
                  <p>
                    <span>
                      业务类型：{{ osg.codelabel('productBizType', item.productBizType) }}
                    </span>
                  </p>
                  <p>
                    <span>依赖产品：{{ osg.codelabelForArray('product', item.depends) }}</span>
                  </p>
                  <p>
                    <span>子产品：{{ osg.codelabelForArray('product', item.childs) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'warrantyProductInventory',
  data() {
    window.$this = this;
    return {
      id: null,
      tenantId: '',
      type: '',
      typeName: '产品',
      collapse: true,
      activeCollapse: '1',
      formData: { exts: {}, productList: [] },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_productType: { codeId: 'productType' },
        codecfg_productBizType: { codeId: 'productBizType' },
        codecfg_unit: { codeId: 'partUnit' },
        codecfg_units: { codeId: 'UNIT' },
        codecfg_tools: { codeId: 'tools' },
        codecfg_productState: { codeId: 'productState' }
      },
      rules: this.$util.rules,
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      activeTab: 'log',
      isShow: false
    };
  },
  mounted() {
    this.id = this.osg.param('id');
    // 当前用户tenantId
    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;

    this.osg.getFields('warrantyProductInventory', () => {
      this.getData();
      this.doInit();
    });
    this.getLog();
    this.getNote();
    // this.getProduct();
    // this.getOrgs();
  },
  methods: {
    formatProductState(val) {
      return this.osg.codelabel('productState', val);
    },
    pageSizeChange(pageSize) {
      if (this.material.open) {
        this.material.notAddedFpi.rows = pageSize;
        this.getNotAddedMaterials();
      } else {
        this.procedure.fpi.rows = pageSize;
        this.getProcedures();
      }
    },
    pageChange(currentPage) {
      if (this.material.open) {
        this.material.notAddedFpi.page = currentPage;
        this.getNotAddedMaterials();
      } else {
        this.procedure.fpi.page = currentPage;
        this.getProcedures();
      }
    },
    getData() {
      this.osg.ajax(
        `basic/warrantyProductInventory/findById/${this.id}.do`,
        {},
        res => {
          let row = res.entity;
          row.exts = row.exts || {};
          this.$util.renderExtField(this.extFields, row);
          this.getWarrantyProducts(row.partnerId);
          this.querypartnerSearch(row.partnerId);
          this.formData = row;
          //获取属性修改记录
          this.getHistory();
        },
        {
          noload: true
        }
      );
    },
    doSave() {
      if (this.osg.isRepeatClick('doSave', 5000)) {
        return;
      }
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax(
          'basic/warrantyProductInventory/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    doInit() {
      this.isShow = false;
      this.formData = { exts: {}, productList: [] };
      this.openDetail = false;
      this.querypartnerSearch(null, () => {
        this.isShow = true;
      });
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'warrantyProductInventory',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'warrantyProductInventory'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'warrantyProductInventory',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    getProduct(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'in:state|array-integer#and': '0,1',
        'ne:productType|string#and': ''
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.product = res.data;
        this.$forceUpdate();
      });
    },
    getOrgs(orgIds, resolve) {
      this.osg.ajax(
        'org/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          'in:_id|array#and': orgIds,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          res.data.orgName = '全部';
          this.options.orgs = [res.data];
          console.log(this.options.orgs);
          if (resolve) resolve();
        },
        {
          noload: true
        }
      );
    },
    //查询伙伴
    querypartnerSearch(queryString, cb) {
      var params = {
        page: 1,
        rows: 50,
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:state|integer#and': 1,
        'regex:name|string#or': queryString,
        'is:_id|string#or': queryString
      };
      this.osg.ajax(
        'basic/partner/query.do',
        params,
        res => {
          this.options.partners = res.data;
          this.$forceUpdate();
          if (cb) cb(res.data);
        },
        { noload: true }
      );
    },
    //选择伙伴
    handlePartnerSelect(pId = '') {
      if (pId) {
        let item = this.options.partners.find(item => item._id == pId);
        this.$set(this.formData, 'partnerName', item.name || '');
        this.$set(this.formData, 'partnerCode', item.partnerNumber || '');
        this.$set(this.formData, 'orgId', item.orgId || '');
        this.$set(this.formData, 'part', item._id || '');

        this.getWarrantyProducts(pId);
        delete this.formData.warrantyProductName;
        delete this.formData.warrantyProductCode;
        delete this.formData.warrantyProductId;
      }
    },
    //选择质保卡产品
    selectWarrantyProductChange(wpId) {
      if (wpId) {
        let item = this.options.warrantyProducts.find(item => item._id == wpId);
        //预设字段
        this.$set(this.formData, 'warrantyProductName', item.name || '');
        this.$set(this.formData, 'warrantyProductCode', item.code || '');
        this.$set(this.formData, 'warrantyProductId', item._id || '');
        //扩展字段
        this.$set(this.formData.exts, 'nameCode', item.exts.nameCode || ''); //名称code
        this.$set(this.formData.exts, 'codelabel', item.exts.codelabel || ''); //编号中文
        this.$set(this.formData.exts, 'warrantyProductPrice', item.price || ''); //单价(元)
        this.$set(this.formData.exts, 'warrantyProductUnit', item.unit || ''); //单位
        this.$set(this.formData.exts, 'warrantyProductProductScopeList', item.productList || ''); //使用防水产品
        if (item.exts.area) {
          this.$set(this.formData.exts, 'warrantyProductScopeArea', item.exts.area || ''); //质保卡管理省市区
        }
      } else {
        //预设字段
        delete this.formData.warrantyProductName;
        delete this.formData.warrantyProductCode;
        delete this.formData.warrantyProductId;

        //扩展字段
        delete this.formData.exts.nameCode; //名称code
        delete this.formData.exts.codelabel; //编号中文
        delete this.formData.exts.warrantyProductPrice; //单价(元)
        delete this.formData.exts.warrantyProductUnit; //单位
        delete this.formData.exts.warrantyProductProductScopeList; //使用防水产品
        delete this.formData.exts.warrantyProductScopeArea; //质保卡管理省市区
      }
    },
    //质保卡产品
    getWarrantyProducts(partnerId) {
      if (!partnerId) {
        this.options.warrantyProducts = [];
        return;
      }
      let params = {
        page: 1,
        rows: 50,
        'in:partnerIds|string#or': partnerId,
        'is:countryUse|integer#or': '1',
        'in:state|integer#and': 1
        // notFilterOrgId: '1',
        // notFilterBelongTo: '1'
      };
      this.osg.ajax('basic/warrantyProduct/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.warrantyProducts = res.data;
        this.$forceUpdate();
      });
    },
    // 点击标签栏
    tabClick() {
      // switch (tab.name) {
      //   case 'procedure':
      //     this.getAddedProcedures();
      //     break;
      //   default:
      // }
    }
  },
  watch: {
    // laborCost() {
    //   this.formData.cost = this.laborCost;
    // },
    // laborFee() {
    //   this.formData.price = this.laborFee;
    // }
  }
};
</script>
<style lang="scss">
.product .c-dialog {
  min-width: 1000px !important;
}
.c-min-height-80vh {
  min-height: 80vh;
}
.product .c-dialog.c-min-width-600 {
  min-width: 600px !important;
}
.c-radio-group {
  display: flex !important;
}
</style>
